import script from "./FormTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormTextarea.vue?vue&type=script&setup=true&lang=ts"

import "./FormTextarea.vue?vue&type=style&index=0&id=32fb4b2d&lang=scss"

const __exports__ = script;

export default __exports__